
namespace SP {
    export enum PicklistType {
        Standard = 1,
        Grouped = 2,
    }
}


